import type { ComponentRef, Ref } from "react";
import { useTranslation } from "react-i18next";

import type { CountState } from "../api/useSegmentCounts";

import { Badge } from "@/components/ui/v2/badge";
import { cn } from "@/lib/utils/cn";
import { useValueFormatter } from "@/utils/useValueFormatter";

type VacancyCountBadgeProps = CountState & {
  testId: string;
  badgeRef?: Ref<ComponentRef<typeof Badge>>;
};

export function VacancyCountBadge({ count, isFetching, testId, badgeRef }: VacancyCountBadgeProps) {
  const { t } = useTranslation();
  const { format } = useValueFormatter();

  if (count === undefined) {
    return (
      <Badge ref={badgeRef} variant="info" data-testid={testId}>
        {t("admin.segments.builder.noCount")}
      </Badge>
    );
  }

  return (
    <Badge
      ref={badgeRef}
      variant="info"
      data-testid={testId}
      aria-busy={isFetching}
      className={cn("transition-opacity duration-150", isFetching && "opacity-60")}
    >
      {t("admin.segments.builder.vacancyCount", { count, formatted: format(count, "whole") })}
    </Badge>
  );
}
